<template>
	<div class="flex flex-col w-full justify-between py-3 px-4 border-ihh-gray/40">
		<div>
			<div class="flex w-full items-center">
				<div class="justify-center text-center mr-6">
					<div class="flex justify-center items-center space-x-8 shrink-0 min-w-[70px] min-h-[70px]">
						<img class="max-w-[70px] max-h-[70px] object-contain" :src="item.variant?.imageUrl || item.item.images?.find((image) => image.isThumbnail)?.url" />
					</div>
				</div>

				<div class="flex flex-col w-full gap-y-2">
					<div class="w-full flex justify-between text-ihh-midnight-gray text-sm">
						<div class="flex flex-wrap line-clamp-2 max-w-[164px]">{{ item.quantity }} x {{ item.item.name }}</div>
						<div>${{ lineTotal }}</div>
					</div>
					<div v-if="item.variant" class="text-ihh-gray-700 px-2 text-xs">
						<div v-for="option in item.variant.optionValues" :key="option.label">
							<span class="text-ihh-midnight-gray font-semibold">{{ `${option.optionDisplayName}: ` }}</span>
							<span class="text-ihh-gray-700 font-normal">{{ option.label }}</span>
						</div>
						<div v-if="XCoverProducts.includes(item.item?.bcId)">
							<span class="text-ihh-midnight-gray font-semibold">{{ `Covered Product Code: ` }}</span>
							<span class="text-ihh-gray font-normal">{{ item.optional?.coveredProductCode }}</span>
						</div>
						<div v-if="XCoverProducts.includes(item.item?.bcId)">
							<span class="text-ihh-midnight-gray font-semibold">{{ `Covered Product: ` }}</span>
							<span class="text-ihh-gray font-normal">{{ item.optional.productName }}</span>
						</div>
					</div>
					<div class="flex w-full justify-between sm:pt-4 lg:pt-0"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'CheckoutCartItem',
	props: {
		item: {
			type: Object,
			required: true,
			validator: (item) => 'item' in item && 'quantity' in item,
		},
		XCoverProducts: {
			type: Array,
			default: () => [],
		},
	},
	computed: {
		currentPrice() {
			// If no variant or quantity is invalid, return the regular price
			if (!this.item.variant?.currentPrice || !this.item.quantity || this.item.quantity <= 0) {
				return this.item.variant?.currentPrice || this.item.item?.currentPrice
			}

			// If no bulk pricing rules available, return the regular price
			if (!this.item.item?.bulkPricingRules || this.item.item.bulkPricingRules.length === 0) {
				return this.item.variant?.currentPrice || this.item.item?.currentPrice
			}

			// Find the applicable bulk pricing rule based on quantity
			const applicableRule = this.item.item.bulkPricingRules
				.filter((rule) => this.item.quantity >= rule.quantityMin && (rule.quantityMax === 0 || this.item.quantity <= rule.quantityMax))
				.sort((a, b) => b.quantityMin - a.quantityMin)[0] // Get the rule with the highest min quantity that applies

			// If no applicable rule found, return the regular price
			if (!applicableRule) {
				return this.item.variant?.currentPrice || this.item.item?.currentPrice
			}

			// Base price to apply discount to
			const basePrice = this.item.variant?.currentPrice || this.item.item?.currentPrice

			// Calculate price based on the rule type
			switch (applicableRule.type) {
				case 'price':
					// Price adjustment per product (subtract the amount from the original price)
					return basePrice - applicableRule.amount
				case 'percent':
					// Percentage discount (apply percentage reduction to original price)
					return basePrice * (1 - applicableRule.amount / 100)
				case 'fixed':
					// Fixed price regardless of original price
					return applicableRule.amount
				default:
					return basePrice
			}
		},
		formattedPrice() {
			return this.currentPrice?.toFixed(2)
		},
		lineTotal() {
			return (this.currentPrice * this.item.quantity).toFixed(2)
		},
	},
}
</script>
